import { render, staticRenderFns } from "./RoommateRequest.vue?vue&type=template&id=76ea944f&scoped=true&"
import script from "./RoommateRequest.vue?vue&type=script&lang=tsx&"
export * from "./RoommateRequest.vue?vue&type=script&lang=tsx&"
import style0 from "./RoommateRequest.vue?vue&type=style&index=0&id=76ea944f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ea944f",
  null
  
)

export default component.exports